import styled from "styled-components";
import { Modal } from "components/Modal";

export const TransactionSuccessModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 560px;

    .modal-content {
      padding: 0;
      border-radius: 16px;
      overflow: hidden;
      position: relative;

      .modal-body {
        padding: 0;
        margin-top: 0;

        .modal-header {
          padding: 20px 24px;
          border-bottom: 1px solid ${({ theme }) => theme.input.border.color};

          .modal-title {
            margin: 0;
            font-size: 18px;
            font-weight: 500;
            color: ${({ theme }) => theme.card.font.tertiary};
            font-family: "Geist", sans-serif;
          }
        }

        .modal-body-content {
          padding: 32px 24px 24px;
          text-align: center;
          position: relative;
          overflow: hidden;

          .content-wrapper {
            position: relative;
            z-index: 2;
          }

          .celebration-icons {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            margin-bottom: 16px;
            font-size: 32px;

            .confetti-icon {
              animation: float 2s ease-in-out infinite;

              &:nth-child(1) {
                animation-delay: 0s;
              }
              &:nth-child(2) {
                animation-delay: 0.2s;
              }
              &:nth-child(3) {
                animation-delay: 0.4s;
              }
              &:nth-child(4) {
                animation-delay: 0.6s;
              }
            }

            @keyframes float {
              0%,
              100% {
                transform: translateY(0) rotate(0deg);
              }
              50% {
                transform: translateY(-10px) rotate(10deg);
              }
            }
          }

          .success-title {
            font-size: 20px;
            font-weight: 500;
            color: #2d8c44;
            margin: 0 0 12px 0;
            font-family: "Geist", sans-serif;
            text-align: left;
          }

          .success-message {
            font-size: 18px;
            font-weight: 600;
            color: rgba(10, 13, 18, 0.9);
            margin: 0 0 24px 0;
            line-height: 1.5;
            font-family: "Aeonik", sans-serif;
            text-align: left;
          }

          .info-banner {
            display: flex;
            gap: 12px;
            padding: 12px 16px;
            background: #eff6ff;
            border: 1px solid #bfdbfe;
            border-radius: 8px;
            margin-bottom: 24px;
            text-align: left;

            .info-icon {
              flex-shrink: 0;
              width: 20px;
              height: 20px;
              color: #3b82f6;
              display: flex;
              align-items: center;
              justify-content: center;

              svg {
                width: 20px;
                height: 20px;
              }
            }

            .info-text {
              font-size: 14px;
              font-weight: 400;
              color: #1e40af;
              line-height: 1.5;
              margin: 0;
              font-family: "Geist", sans-serif;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0 16px;

      .modal-content {
        .modal-body {
          .modal-header {
            padding: 16px 20px;

            .modal-title {
              font-size: 16px;
            }
          }

          .modal-body-content {
            padding: 24px 20px 20px;

            .success-title {
              font-size: 18px;
            }

            .success-message {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
`;
